export enum UserRole {
  Admin = "admin",
  Assistant = "assistant",
  ChiefAssistant = "chiefassistant",
  SupAssistant = "supassistant",
}
